import { render, staticRenderFns } from "./add-course-dialog.vue?vue&type=template&id=08f026ba&scoped=true&"
import script from "./add-course-dialog.vue?vue&type=script&lang=js&"
export * from "./add-course-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-course-dialog.vue?vue&type=style&index=0&id=08f026ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f026ba",
  null
  
)

export default component.exports